import script from "./CMoveSort.vue?vue&type=script&setup=true&lang=ts"
export * from "./CMoveSort.vue?vue&type=script&setup=true&lang=ts"

import "./CMoveSort.vue?vue&type=style&index=0&id=4feebfdf&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4feebfdf"]])

export default __exports__